import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const TERMS_URL = `${process.env.PUBLIC_URL}/legal/terms-and-conditions.md`;

function TermsDialog({ open, onClose, title = 'Términos y Condiciones', url = TERMS_URL }) {
    const [text, setText] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (!open || text || error) return;
        fetch(url)
            .then((res) => {
                if (!res.ok) throw new Error(`No se pudo cargar "${title}"`);
                return res.text();
            })
            .then(setText)
            .catch((err) => setError(err.message));
    }, [open, url, title, text, error]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" scroll="paper">
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>
                {error && <Typography color="error">{error}</Typography>}
                {!error && !text && <Typography color="text.secondary">Cargando…</Typography>}
                {!error && text && (
                    <Box
                        sx={{
                            '& h1': { fontSize: '1.4rem', fontWeight: 700, mt: 0, mb: 1.5 },
                            '& h2': { fontSize: '1.1rem', fontWeight: 700, mt: 3, mb: 1 },
                            '& p': { mb: 1.5, lineHeight: 1.7 },
                            '& ul, & ol': { mb: 1.5, pl: 3 },
                            '& li': { mb: 0.5, lineHeight: 1.6 },
                            '& hr': { my: 2, border: 'none', borderTop: '1px solid', borderColor: 'divider' },
                            color: 'text.primary',
                        }}
                    >
                        <ReactMarkdown>{text}</ReactMarkdown>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
}

export default TermsDialog;
